'use client'

import useSWR from 'swr'
import { Card, CardContent } from '@/components/ui/card'
import { Calendar, FileText, Landmark } from 'lucide-react'
import apiService from '@/app/services/apiService'

export default function VendorContractsCard() {
  const { data, error, isLoading } = useSWR(
    '/api/contracts/vendor/',
    (url) => apiService.getWithToken(url)
  )

  if (isLoading) return <p>Carregando contratos...</p>
  if (error) return <p className="text-red-500">Erro ao carregar contratos.</p>
  if (!data || data.length === 0) return <p className='text-center'>Carregando contrato... (0%)</p>

  return (
    <div className="grid gap-4 mt-6">
      <h2 className="text-xl font-semibold">Meus contratos pagos</h2>
      {data.map((contract: any) => (
        <Card key={contract.id}>
          <CardContent className="p-4 space-y-2">
            <div className="flex items-center gap-2 text-sm">
              <Landmark className="w-4 h-4" />
              <span className="font-semibold">{contract.product_name}</span>
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-600">
              <FileText className="w-4 h-4" />
              <span>{contract.contract_client || 'Sem descrição'}</span>
            </div>

            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Calendar className="w-4 h-4" />
              <span>Prazo: {contract.deadline || 'Não informado'}</span>
            </div>

            <div className="flex justify-between pt-2 border-t text-sm">
              <span>Total: R$ {parseFloat(contract.contract_total).toFixed(2)}</span>
              <span className="text-green-600 font-medium">
                Receberá: R$ {parseFloat(contract.vendor_receives).toFixed(2)}
              </span>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
